<template>
<div class="history-page scroll-view" v-scroll-bottom="loadMoreData">
  <div style="min-height: 800px;">
      <div class="record-list">
          <div v-for="(item,index) in recordList" :key="index">
              <div class="record-item" @click="handleDetail(item)" >
                  <div class="record-titile flex">
                      <span>{{item.myDate}}</span>
                  </div>
                  <div class="record-content">
                      <div class="arrow price-value">
                          ￥<span style="font-size: 16px;font-weight: bold;">{{item.preDotPrice}}</span>
                          <span style="font-size: 12px;">.{{item.nextDotPrice}}</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="load-more" v-if="hasMore">上滑加载更多</div>
      <div class="load-more" v-if="!hasMore">没有更多了</div>
  </div>
  <!-- <Toast type="loading" v-if="showToast">{{ message }}</Toast> -->
</div>
</template>
<script>
import { getRecord } from '@/services/order'
// import Toast from 'vue-weui/components/toast/toast.vue'

export default {
  components:{
    // Toast
  },
  data() {
    return {
      page: 1,
      recordList: [],
      hasMore: false,
      showToast: false
      // message: '正在加载数据...'
    }
  },
  created() {
    this.recordList = []
    this.getRecordList()
  },
  methods: {
    getRecordList() {
      this.$showToast({
        type: 'loading',
        toastMessage: '正在加载数据...',
        duration: 2000 
      })
      // this.showToast = true
      getRecord({ limit: 12, page: this.page }).then(res => {
          this.hasMore = res.data.hasMore
          res.data.settlements.forEach(set =>{
              set.myDate = `${set.year} 年 ${parseInt(set.month)} 月`
              const p = set.hkjActualFee.split('.')
              set.preDotPrice = p[0]
              set.nextDotPrice = p[1]
              this.recordList.push(set)
          })
          // setTimeout(() => {
            // this.showToast = false
              // wx.hideLoading()
          // },500)
          
      }).catch(() => {
        // this.showToast = false
      })
    },
    loadMoreData() {
      this.page++
      this.getRecordList()
    },
    handleDetail(item) {
      this.$router.push(`/settlementDetail/${item.settlementId}`)
    }
  }
}
</script>
<style scoped>
/* pages/historyrecord/index.wxss */
.record-list{
    display: flex;
    flex-wrap: wrap;
    --webkit-box-pack: justify;
    justify-content: space-between;
}
.record-list {
    padding: var(--len10);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: var(--len10);
}
.record-item{
    /* min-width: var(--len200); */
    height: var(--len100);
    border-radius: var(--len5);
    /* border-radius: 5px;
     */
    background-color: #ffffff;
    margin-bottom: var(--len10);
}
.record-titile{
    font-size: var(--len14);
    font-weight: bold;
    border-bottom: 0.5px solid #cccccc;
    height: var(--len40);
    line-height: var(--len40);
    width: 100%;
    display: inline-block;
    text-align: center;
}
.price-value{
    position: relative;
    /* width: 80px; */
}
.record-content{
    color: var(--primary-color);
    display: flex;
    align-items: center;
    justify-content: center;
    /* line-height: 100px; */
    padding-top: 16px;
}
.arrow::after{
    top: var(--len10);
    right: - var(--len10);
    border-color: var(--primary-color);
}

</style>